<template lang="pug">
.container-wrapper
  el-dialog(:close-on-click-modal="false",
    :visible.sync="showPlaylogVisible",
    @close='showPlaylogVisible = false',
    fullscreen
  )
    Playlog(
      v-if='showPlaylogVisible === true',
      ref='Playlog',
      :entity='playlogEntity',
      @finished='showPlaylogVisible = false',
      @showPlaylogForNetwork='showPlaylogForNetwork',
      @showPlaylogForMedium='showPlaylogForMedium',
      @showPlaylogForDevice='showPlaylogForDevice'
    )
  .container-main
    //- shortkey has to be in a component so let's put in el-header
    el-header.main-header
    .el-menu-top
      .menu-item.logo
        .logo-content(id="Layout-logo" @click="goHome()")
      .menu-right
        .menu-item-right.network-location
          .network-location-content
            span(v-if='currentUserNetwork') &nbsp; {{ currentUserNetwork.name }}
        .menu-item-right.site-language
          el-dropdown(trigger="click", @command="changeLang")
            el-button(
              size="mini",
              type="text",
              :title="$t('Choose language')",
              id="Layout-chooseLanguageButton"
            )
              img(:src='getLocaleImageSource(this.$i18n.locale)')
            el-dropdown-menu(slot='dropdown')
              el-dropdown-item(:command="language", v-for="language in siteLanguages", :key='language', :id="'Layout-languageOption-' + language")
                img.dropdown-language-image(:src='getLocaleImageSource(language)')
        .menu-item-right.fixed-right.nick
          span &nbsp; {{ this.$store.state.User.user.nick }} &nbsp;
          el-button(type="text", size="mini", @click='logout()') &nbsp;
            font-awesome-icon(icon="right-from-bracket")
  .configurable-items
    p.warning(v-if='isLoading') {{ 'Loading data' }} &nbsp;
      font-awesome-icon.spinner-icon.fa-pulse(icon="spinner")
    ConfigurablePlayItem(v-if='!isLoading', v-for="configurableItemInDesktop in configurableItemsInDesktops", :playitem='configurableItemInDesktop', :key='configurableItemInDesktop.path')
  .status-bar-server(v-if='wsStatusMalfunction')
    span {{$t('Server slow down or malfunction detected.')}}
    p {{$t('You may experience some inconvenience...')}}
    p {{  this.$store.state.Error.ws_status.status }}
    p {{  this.$store.state.Error.ws_status.modified  }}
</template>

<script>
import textUtils from './Common/textUtils.mixin'
import userUtils from './Common/userUtils.mixin'
import Playlog from './Common/Playlog'
import ConfigurablePlayItem from './Medium/OnlyOwnMedia/PlayItem.vue'
import Vue from 'vue'

export default {
  mixins: [textUtils, userUtils],
  name: 'Layout',
  components: {
    Playlog,
    ConfigurablePlayItem
  },
  props: [
  ],

  data () {
    return {
      isLoading: false,
      PlayItemId: undefined,
      showPlaylogVisible: false,
      playlogEntity: undefined,
      focusSide: 'left',
      siteLanguages: ['en', 'pl'],
      localPlaylistsWithPermision: [],
      configurableItemsInDesktops: []
    }
  },
  async created () {
    this.isLoading = true
    this.$store.dispatch('User/getMe')
    this.localPlaylistsWithPermision = this.$store.state.User.user.MediaWithEditPermission.filter(m => m.type === 'PlayListDesktop')
    await this.$store.dispatch('Device/getDeviceList', {}, { root: true })
    await this.$store.dispatch('Medium/getMediaList', {}, { root: true })
    await this.getConfigurableMedia()
    this.isLoading = false
  },
  methods: {
    async logout () {
      await this.$store.dispatch('User/logout', {})
      this.$router.push({ path: '/login' })
    },
    async getConfigurableMedia () {
      for (const localPlaylist of this.localPlaylistsWithPermision) {
        const configurableContent = (await Vue.axios.post('medium/preparePlaylistContentFlat', { PlayList: localPlaylist.id }))
          .data.rows.filter(pli => ['PlayListExtended', 'PlayListLayoutExtended', 'HTML5app'].includes(pli.type))
        for (const configurableContentItem of configurableContent) {
          configurableContentItem.deviceDesktop = localPlaylist.DeviceDesktop
          this.configurableItemsInDesktops.push(configurableContentItem)
        }
      }
    },
    async changeLang (lang) {
      this.$i18n.locale = lang
      await Vue.axios.post('user/setViewPreference', {
        language: lang
      })
      await this.$store.dispatch('User/getMe')
    },
    isActiveLang (lang) {
      return this.$i18n.locale === lang
    },
    getLocaleImageSource (locale) {
      return `/static/${locale}.svg`
    }
  },
  computed: {
    wsStatusMalfunction () {
      if (this.$store.state.Error.ws_status === {}) return false
      return this.$store.state.Error.ws_status.status !== 200 || this.$store.state.Error.ws_status.modified < new Date().now - 11 * 1000
    }
  }
}
</script>
<style lang='scss' scoped>
@import "../../theme-m4b/src/common/var.scss";
.configurable-items {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.status-bar-server {
  position: fixed;
  z-index: 1000001;
  border: 1px solid $--color-danger;
  width: 300px;
  margin-left: calc(47.6vw - 150px);
  bottom: -2px;
  text-align: center;
  border-radius: 3px;
  background-color: rgba(#000, 0.25);
  color: $--color-text-regular;
  p {
    color: $--color-text-secondary;
  }
}

.main-header {
  padding: 0px !important;
}
.dropdown-language-image {
  width: 18px;
  height: 13px;
}
.el-menu-top {
  background-color: $--color-white;
  border: $--border-light;
  display: flex;
  // justify-content: flex-start;
  border: 0px dotted red;
  height: 70px;
  .menu-right {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .menu-item-right {
      margin: 0px 10px;
    }
    .site-language {
      img {
        width: 18px;
        height: 13px;
      }

    }
    .nick {
      font-size: $--font-size-small;
    }
  }
  @keyframes pulse-w {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
  .menu-item {
    &.logo  {
      // width: 25vw;
      .logo-content {
        height: 37px;
        width: 130px;
        cursor: pointer;
        background: url('/static/wave2-logo.svg') 100% no-repeat;
        background-size: contain;
        margin: 5px 0px 0px 10px;
      }
    }
    &.network-location {
      // width: 25vw;
      .network-location-content {
        display: flex;
        height: 57px;
        align-items: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LayoutOnlyOwnMedia.vue